import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PermissionState {
  read: boolean;
  create: boolean;
  update: boolean;
}

const initialState: PermissionState = {
  read: false,
  create: false,
  update: false,
};

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<PermissionState>) {
      state.read = action.payload.read;
      state.create = action.payload.create;
      state.update = action.payload.update;
    },
    clearPermissions(state) {
      state.read = false;
      state.create = false;
      state.update = false;
    },
  },
});

export const { setPermissions, clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
